// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__fucya","dots":"Menu_dots__d+HfQ","dropdown":"Menu_dropdown__NQoJF"};